<template>
  <div>
    <b-modal ref="sla-date-modal" id="sla-date-modal" :title="showTitle" size="lg" hide-footer>
      <b-card-text v-if="isInitial">
        <b-row>
          <b-col cols="12">            
            <b-alert v-if="isNewTime" show variant="danger" >
              <div class="alert-body">
                  <span style="font-size:1.2em"><strong>  <feather-icon icon="AlertTriangleIcon" size="20"/> ***ยังไม่ได้มีการบันทึกเวลา กรุณากำหนดเวลาให้กับ Cat และกดบันทึก</strong> </span>
                </div>
                
            </b-alert>
          </b-col>
        </b-row>

        <b-row v-for="day in days" :key="day.value" class="align-items-center b-row-hover pt-1 pb-1 mb-1 border rounded shadow" :class="{ 'bg-sky': !isDarkMode && dayChecked[day.value], 'bg-darkmode':isDarkMode && dayChecked[day.value] }">
          <!-- Checkbox -->
          <b-col cols="4" class="d-flex align-items-center ">
            <b-form-checkbox value="true" v-model="dayChecked[day.value]">
              <b class="cursor-pointer" :class="{ 'text-darkmode':isDarkMode && dayChecked[day.value] }">{{ day.text }}</b>
            </b-form-checkbox>
          </b-col>

          <!-- เริ่มต้น -->
          <b-col cols="4" class="d-flex align-items-center ">
            <label  :class="{ 'text-darkmode':isDarkMode && dayChecked[day.value] }">เวลาเริ่มต้น : </label>
            <Timepicker class="ml-1" :value="times[day.value].startTime" @input="times[day.value].startTime = $event"/>
          </b-col>

          <!-- สิ้นสุด -->
          <b-col cols="4" class="d-flex align-items-center">
            <label  :class="{ 'text-darkmode':isDarkMode && dayChecked[day.value] }">เวลาสิ้นสุด : </label>
            <Timepicker class="ml-1" :value="times[day.value].endTime" @input="times[day.value].endTime = $event"/>
          </b-col>
        </b-row>


        <!--- START (BTN SUBMIT) --->
        <b-row class="mt-1">
          <b-col class="d-flex justify-content-start text-primary font-weight-bold">
            เลือกทั้งหมด {{ countChecked }} วัน
            
          </b-col>
          <b-col md="8" class="d-flex justify-content-end">
            
            <b-button v-if="catSettingSelected" @click="onSubmit" variant="primary" size="sm">
              <span v-if="isLoading">กำลังบันทึก...</span>
              <span v-else>
                บันทึก
              </span>
            </b-button>
            <span v-if="!catSettingSelected || catSettingSelected==0" class="text-danger">**กรุณากรอกจำนวนชั่วโมงก่อนทำการตั้งค่าเวลา</span>
          </b-col>
        </b-row>
        <!--- END (BTN SUBMIT) --->
      </b-card-text>

      <b-card-text v-else>
        <b-row>
          <b-col cols="12" >
           กำลังโหลดข้อมูล....
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import Timepicker from "../timepicker.vue";
import useAppConfig from '@core/app-config/useAppConfig'

import {
  VBModal,
  BCardText,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormDatepicker,
  BFormTimepicker,
  BFormCheckbox,
  BFormGroup,
  BAlert,

} from "bootstrap-vue";

const INIT_TIME = {
        monday: {
          startTime: "00:00",
          endTime: "23:59"
        },
        tuesday: {
          startTime: "00:00",
          endTime: "23:59"
        },
        wednesday: {
          startTime: "00:00",
          endTime: "23:59"
        },
        thursday: {
          startTime: "00:00",
          endTime: "23:59"
        },
        friday: {
          startTime: "00:00",
          endTime: "23:59"
        },
        saturday: {
          startTime: "00:00",
          endTime: "23:59"
        },
        sunday: {
          startTime: "00:00",
          endTime: "23:59"
        },
      }

export default {
  components: {
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BFormDatepicker,
    BFormTimepicker,
    BFormCheckbox,
    BAlert,
    BFormGroup,
    Timepicker
  },
  directives: {
    "b-modal": VBModal,
  },


  data() {
    return {
      isNewTime: false,
      times:INIT_TIME,
      dayChecked: {
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true,
        sunday: true
      },
      isLoading: false,
      isInitial: false,
      days: [
        { text: 'วันจันทร์', value: 'monday' },
        { text: 'วันอังคาร', value: 'tuesday' },
        { text: 'วันพุธ', value: 'wednesday' },
        { text: 'วันพฤหัสบดี', value: 'thursday' },
        { text: 'วันศุกร์', value: 'friday' },
        { text: 'วันเสาร์', value: 'saturday' },
        { text: 'วันอาทิตย์', value: 'sunday' },
      ],      
    };
  },

  computed: {
    isDarkMode(){
      const { skin } = useAppConfig()
      return skin.value == "dark" ? true : false
    },
    countChecked(){
      return Object.keys(this.dayChecked).filter(key => this.dayChecked[key]).length;
    },
    showTitle() {
      let cat = this.$store.getters["sla/getSlaSelected"] || "";
      let alias = this.$store.getters["sla/getTabAliasSelected"] || "";
      let tab = this.$store.getters["sla/getTabSelected"] || "";

      if(tab == "cm"){
          return `ตั้งค่าวันเวลา ${cat?.catName} (${alias}) - ${this.$store.getters["sla/getCmCentralText"] || ""}`
      }
      return `ตั้งค่าวันเวลา ${cat?.catName} (${alias})`
    },
    paramSubCompanyId() {
      return this.$route.query.scid
    },
    catTimeSelected(){
      return this.$store.getters["sla/getCatTimeSelected"];
    },
    catSettingSelected(){
      const catSettingValue = this.$store.getters["sla/getCatSettingSelected"];
      const slaSelected = this.$store.getters["sla/getSlaSelected"];
      console.log("slaSelected=>", slaSelected)
      return catSettingValue[slaSelected?.catCode]
    }
  }, 
  
  watch: {
    catTimeSelected(val){  
      this.isInitial = false
      this.times = null
      
      //IF VALUE IS NOT EMPTY
      if(val && Object.keys(val).length > 0){     
        this.isNewTime = false
        this.times = val
        for(let key in val){        
          this.dayChecked[key] = val[key].isEnable ==1 ? true : false
        }
      }else{ 
        this.resetModal()       
        this.isNewTime = true
        this.times = {...INIT_TIME}

      }

      setTimeout(() => {
        this.isInitial = true
      }, 500);
      
    }
  },



  methods: {
    hideModal() {
      this.$refs["sla-date-modal"].hide();
    },
    buildDataBeforeSubmit(){
      let outputs = []
      let cat = this.$store.getters["sla/getSlaSelected"]
      let tab = this.$store.getters["sla/getTabSelected"] || "";

      const model = {
        brandId:this.paramSubCompanyId,
        catCode:cat.catCode,
        day:"",
        startTime:"",
        endTime:"",
        isEnable:false,
        type:tab
      }
      
      for(let key in this.times){       
        const item = {...model, day:key, isEnable:this.dayChecked[key], startTime: this.times[key].startTime, endTime: this.times[key].endTime}
        outputs.push(item)                 
      }

    
      return outputs
    },
    onSubmit(){
      const data = this.buildDataBeforeSubmit()
      let tab = this.$store.getters["sla/getTabSelected"] || "";
      this.$emit("onSubmit", data, this.isNewTime, tab);
      this.hideModal();
    },
    resetModal() {
      this.isNewTime = false;
      this.times = { ...INIT_TIME };
      this.dayChecked = {
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true,
        sunday: true
      };
      this.isLoading = false;
      this.isInitial = false;
  },
  },

};
</script>

<style scoped>
.modal-title {
  font-size: 1.5em !important;
}

/* .b-row-hover:hover {
  background-color: #d8e3e5 !important;
} */

.bg-sky{
  background-color: #d8e3e5 !important;
}

.bg-darkmode{
  background-color: #d8e3e5 !important;  
}

.text-darkmode{
  color: #000000 !important;
}
</style>
